import itemsSubcategory from '../stips/category/itemsSubcategory';

// Sajt je samo na srpskom: parametar `lang` se zadržava zbog postojećih poziva, ali se ne koristi.
export default class IncludesTable{
  static convert(description, lang){
    return this.srTitle(description)
  }
   static srTitle(description){
    let res =  description.split('-za-mesec-')[0].split('-').join(' ');
    let find  = itemsSubcategory.subcategory.filter(x=> x.description_path.toLowerCase() == res);
    if(find.length > 0){
      return find[0].value
    }
    return []
   }
}
